import { render } from "./PayPage.vue?vue&type=template&id=1b86112f"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"

import "./PayPage.vue?vue&type=style&index=0&id=1b86112f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__